import { cn } from '@/components/ui/cn';
import { Text, type TextProps } from '@/components/ui/Text';

/** Bakes `font-heading`; size/color are passed per call. */
export const Heading = (p: TextProps) => (
  <Text variant="none" {...p} className={cn('font-heading', p.className)} />
);
